module.exports = __webpack_public_path__ + "img/back-log.dde3c0fd.jpg";